import React, { createContext, useContext, useEffect, useState } from "react";

const dict = {
  en: {
    appName: "MER Educational Consultancy",
    tagline: "Study Abroad CRM",
    login: "Sign in", logout: "Sign out",
    email: "Email", password: "Password",
    signIn: "Sign in", signInSubtitle: "Access your consultancy dashboard",
    dashboard: "Dashboard", students: "Students", pipeline: "Pipeline",
    tasks: "Tasks & Reminders", team: "Team", settings: "Settings",
    totalStudents: "Total students", conversionRate: "Enrolled conversion",
    openTasks: "Open tasks", overdueTasks: "Overdue tasks",
    studentsPerCountry: "Students per destination", pipelineFunnel: "Pipeline funnel",
    addStudent: "Add student", newStudent: "New student",
    name: "Full name", phone: "Phone", nationality: "Nationality",
    educationLevel: "Education level", targetCountries: "Target countries",
    stage: "Stage", notes: "Notes", save: "Save", cancel: "Cancel",
    search: "Search students…", globalSearch: "Search anywhere: name, phone, passport…",
    documents: "Documents", activity: "Activity",
    addNote: "Add note", addTask: "Add reminder",
    title: "Title", dueDate: "Due date", upload: "Upload",
    uploadDocument: "Upload document", docType: "Document type",
    passport: "Passport", transcripts: "Transcripts", certificate: "Certificate", other: "Other",
    createdOn: "Created", view: "View", delete: "Delete",
    complete: "Complete", completed: "Completed",
    open: "Open", all: "All", stages: "Stages",
    kind: "Kind", call: "Call", meeting: "Meeting", followup: "Follow-up", note: "Note",
    empty: "Nothing here yet.",
    addEmployee: "Add employee", role: "Role", admin: "Admin", employee: "Employee",
    invalidLogin: "Invalid email or password", language: "Language",
    dueToday: "Due today", overdue: "Overdue", upcoming: "Upcoming",
    student: "Student", unassigned: "Unassigned",
    yourName: "Your name", createAccount: "Create employee account",
    downloadOrView: "Open", contact: "Contact info",
    quickStats: "Quick stats", recentStudents: "Recent students",
    noStudents: "No students yet. Add your first one to get started.",
    passportNumber: "Passport number",
    whatsapp: "WhatsApp", whatsappMsg: "Send WhatsApp",
    sendReminders: "Send reminder emails",
    reminderSent: "Reminders sent",
    noResults: "No matches",
    quickActions: "Quick actions",
  },
  ar: {
    appName: "MER للاستشارات التعليمية",
    tagline: "نظام إدارة الدراسة في الخارج",
    login: "تسجيل الدخول", logout: "تسجيل الخروج",
    email: "البريد الإلكتروني", password: "كلمة المرور",
    signIn: "دخول", signInSubtitle: "الوصول إلى لوحة الاستشارات",
    dashboard: "لوحة التحكم", students: "الطلاب", pipeline: "المسار",
    tasks: "المهام والتذكيرات", team: "الفريق", settings: "الإعدادات",
    totalStudents: "إجمالي الطلاب", conversionRate: "نسبة التسجيل",
    openTasks: "مهام مفتوحة", overdueTasks: "مهام متأخرة",
    studentsPerCountry: "الطلاب حسب الوجهة", pipelineFunnel: "قمع المسار",
    addStudent: "إضافة طالب", newStudent: "طالب جديد",
    name: "الاسم الكامل", phone: "الهاتف", nationality: "الجنسية",
    educationLevel: "المستوى الدراسي", targetCountries: "الدول المستهدفة",
    stage: "المرحلة", notes: "ملاحظات", save: "حفظ", cancel: "إلغاء",
    search: "ابحث عن طالب…", globalSearch: "ابحث في كل مكان: الاسم، الهاتف، جواز السفر…",
    documents: "المستندات", activity: "النشاط",
    addNote: "إضافة ملاحظة", addTask: "إضافة تذكير",
    title: "العنوان", dueDate: "تاريخ الاستحقاق", upload: "رفع",
    uploadDocument: "رفع مستند", docType: "نوع المستند",
    passport: "جواز السفر", transcripts: "كشف الدرجات", certificate: "شهادة", other: "أخرى",
    createdOn: "تاريخ الإنشاء", view: "عرض", delete: "حذف",
    complete: "إتمام", completed: "مكتملة",
    open: "مفتوحة", all: "الكل", stages: "المراحل",
    kind: "النوع", call: "مكالمة", meeting: "اجتماع", followup: "متابعة", note: "ملاحظة",
    empty: "لا يوجد شيء بعد.",
    addEmployee: "إضافة موظف", role: "الدور", admin: "مسؤول", employee: "موظف",
    invalidLogin: "بريد إلكتروني أو كلمة مرور غير صحيحة", language: "اللغة",
    dueToday: "لليوم", overdue: "متأخرة", upcoming: "قادمة",
    student: "الطالب", unassigned: "غير معيّن",
    yourName: "اسمك", createAccount: "إنشاء حساب موظف",
    downloadOrView: "فتح", contact: "معلومات التواصل",
    quickStats: "إحصاءات سريعة", recentStudents: "أحدث الطلاب",
    noStudents: "لا يوجد طلاب بعد. أضف طالبك الأول للبدء.",
    passportNumber: "رقم جواز السفر",
    whatsapp: "واتساب", whatsappMsg: "إرسال عبر واتساب",
    sendReminders: "إرسال رسائل التذكير",
    reminderSent: "تم إرسال التذكيرات",
    noResults: "لا توجد نتائج",
    quickActions: "إجراءات سريعة",
  },
};

// Stage translations (canonical English → Arabic)
const STAGE_AR = {
  "New Lead": "عميل جديد",
  "Documents Collected": "تم جمع المستندات",
  "University Applied": "تم التقديم للجامعة",
  "Accepted": "مقبول",
  "Visa Processing": "معالجة التأشيرة",
  "Enrolled": "مسجّل",
};

// Country translations
const COUNTRY_AR = {
  "Georgia": "جورجيا",
  "Armenia": "أرمينيا",
  "Belarus": "بيلاروسيا",
  "Uzbekistan": "أوزبكستان",
  "Ukraine": "أوكرانيا",
  "Russia": "روسيا",
  "Moldova": "مولدوفا",
  "Romania": "رومانيا",
  "Tajikistan": "طاجيكستان",
  "China": "الصين",
  "Rwanda": "رواندا",
};

// Note kind translations
const KIND_AR = {
  call: "مكالمة",
  meeting: "اجتماع",
  "follow-up": "متابعة",
  note: "ملاحظة",
};

const Ctx = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("mer_lang") || "en");
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    localStorage.setItem("mer_lang", lang);
  }, [lang]);
  const t = (k) => dict[lang][k] ?? k;
  const ts = (stage) => (lang === "ar" ? STAGE_AR[stage] || stage : stage);
  const tc = (country) => (lang === "ar" ? COUNTRY_AR[country] || country : country);
  const tk = (kind) => (lang === "ar" ? KIND_AR[kind] || kind : kind);
  return (
    <Ctx.Provider value={{ lang, setLang, t, ts, tc, tk }}>{children}</Ctx.Provider>
  );
}

export function useI18n() {
  return useContext(Ctx);
}
